<template>
    <div class="cr:lg:w-4xl">
        <div class="cr:rounded-lg cr:bg-white cr:p-7">
            <Transition name="slide" mode="out-in">
                <RegistrationCompleteV4
                    v-if="registrationStore.isComplete"
                    key="complete"
                />
                <div v-else key="form">
                    <RegistrationFormV4
                        ref="formRef"
                    />
                    <div class="cr:mt-5">
                        <CustomButton
                            :color="'origin'"
                            @click="submit"
                            :width-class="'cr:w-full'"
                            :disable-button="registrationStore.isSubmitting"
                        >
                            {{ registrationStore.isSubmitting ? 'Registering...' : 'Register' }}
                        </CustomButton>
                    </div>
                </div>
            </Transition>
            <div class="cr:mt-7 cr:text-center">
                Call us today at
                <a :href="`tel:${configStore.supportPhone}`" class="cr:text-blue-500 cr:font-semibold">{{ configStore.supportPhone }}</a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from "vue";
import {useRegistrationV4Store} from "@/stores/registrationV4.ts";
import {useConfigStore} from "@/stores/config.ts";
import RegistrationFormV4 from "@/components/slides/v4/RegistrationFormV4.vue";
import RegistrationCompleteV4 from "@/components/slides/v4/RegistrationCompleteV4.vue";
import CustomButton from "@/components/elements/CustomButton.vue";

interface FormRef {
    validate: () => boolean;
    slidePayload: Record<string, unknown>;
    setEmailError: (message: string | null) => void;
}

const registrationStore = useRegistrationV4Store();
const configStore = useConfigStore();
const formRef = ref<FormRef | null>(null);

const submit = async () => {
    if (!formRef.value?.validate()) {
        return;
    }

    const success = await registrationStore.submitRegistration(formRef.value.slidePayload);

    if (!success && registrationStore.emailError) {
        formRef.value?.setEmailError(registrationStore.emailError);
    }
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
    opacity: 1;
    transition: opacity 0.5s ease-in 0s;
}

.slide-enter-from,
.slide-leave-to {
    opacity: 0;
    transition: opacity 0.5s 0s;
}
</style>
